import React from 'react';
import HeaderAwarePage from './HeaderAwarePage';
import Header from '../header/header';
import ProfitRoverSkeleton from '../skeleton/ProfitRoverSkeleton';

const GenericSkeletonPage = () => (
  <HeaderAwarePage scrollable={false}>
    <Header />
    <ProfitRoverSkeleton />
  </HeaderAwarePage>
);

export default GenericSkeletonPage;
